import { CameraSensorMode } from 'src/domains/api/cameras/types';
import { ceiling } from 'src/domains/calculators/utilities/ceiling';
import { Resolution } from 'src/domains/calculators/utilities/types';
import { createResolutionFromValues } from './createResolution';

/**
 * Hook for calculating sensor resolution from camera sensor mode or custom dimensions
 * Handles validation and rounding
 */
export const getSensorModeResolution = (
  sensorMode?: CameraSensorMode,
  squeeze: number = 1,
  desqueezed: boolean = false
): Resolution | null => {
  if (!sensorMode) return null;

  // Validate sensor mode dimensions using createResolutionFromValues
  const baseResolution = createResolutionFromValues(
    sensorMode.horizontal,
    sensorMode.vertical
  );

  if (!baseResolution) return null;

  // When in desqueezed mode, we multiply the width by the squeeze factor
  // Apply ceiling rounding to ensure even dimensions
  return {
    width: ceiling(baseResolution.width * (desqueezed ? squeeze : 1), 2),
    height: ceiling(baseResolution.height, 2),
  };
};
